export default {
  stateKey: 'heading-h2',
  order: 1,
  isActiveKey: 'heading',
  commandKey: 'toggleHeading',
  commandProps: { level: 2 },
  icon: ['far', 'h2'],
  appearance: {
    menu: true,
    bubble: true,
  },
}
